import React from "react";
import { CustomChartsTitle, CustomLabel } from "../Custom/CustomTypography";
import {
  TextField,
  MenuItem,
  Select,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  InputLabel,
  Grid,
  Typography,
  FormHelperText,
  InputAdornment,
} from "@mui/material";
import { handleMobileKeyDown } from "../../globals/utils";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const CustomTextField = ({
  label,
  label2,
  name,
  value,
  onChange,
  type,
  options,
  error,
  helperText,
  title,
  name2,
  value2,
  onClick,
  placeholder,
  disabled = false,
  required = false,
}) => {
  const handleChange = (event) => {
    const { name: fieldName, value: fieldValue, checked } = event.target;

    if (type === "checkboxes") {
      let updatedValue = [...value];
      const optionValue = parseInt(fieldValue, 10); // Convert string ID to number
      if (checked) {
        updatedValue.push(optionValue);
      } else {
        updatedValue = updatedValue.filter((item) => item !== optionValue);
      }
      onChange(name, updatedValue);
    } else if (type === "checkbox") {
      onChange(fieldName, checked);
    } else {
      onChange(fieldName, fieldValue);
    }
  };

  if (type === "select" && options) {
    return (
      <>
        {title && <CustomLabel>{title}</CustomLabel>}
        <FormControl fullWidth sx={{ marginTop: "20px" }}>
          <InputLabel>
            {label}
            {required ? " *" : ""}
          </InputLabel>
          <Select
            label={label}
            value={value}
            onChange={handleChange}
            fullWidth
            variant="outlined"
            name={name}
          >
            {options.map((option) => (
              <MenuItem
                key={option.value}
                value={option.value}
                onClick={() => onClick && onClick(option.label)}
              >
                {option.label}
              </MenuItem>
            ))}
          </Select>
          {error && <div style={{ color: "red" }}>{helperText}</div>}
        </FormControl>
      </>
    );
  } else if (type === "checkboxes" && options) {
    return (
      <FormControl
        component="fieldset"
        fullWidth
        sx={{ marginTop: "20px" }}
        error={Boolean(error)}
      >
        <CustomChartsTitle>
          {label}
          {required ? " *" : ""}
        </CustomChartsTitle>
        <FormGroup>
          <Grid container sx={{ marginTop: "10px" }}>
            {options.map((option) => (
              <Grid item xs={6} key={option.value}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={value.includes(option.value)}
                      onChange={handleChange}
                      name={name}
                      value={option.value}
                    />
                  }
                  label={option.label}
                />
              </Grid>
            ))}
          </Grid>
        </FormGroup>
        {error && (
          <FormHelperText style={{ color: "red" }}>{helperText}</FormHelperText>
        )}
      </FormControl>
    );
  } else if (type === "range_values") {
    return (
      <>
        {title && <CustomLabel>{title}</CustomLabel>}
        <Grid container spacing={0} alignItems="center">
          <Grid item xs={5.5}>
            <TextField
              label={label}
              value={value}
              onChange={handleChange}
              fullWidth
              variant="outlined"
              margin="normal"
              type="number"
              name={name}
              error={Boolean(error)}
              helperText={error && helperText}
              required={required}
            />
          </Grid>
          <Grid item xs={1}>
            <Typography variant="body1" align="center">
              -
            </Typography>
          </Grid>
          <Grid item xs={5.5}>
            <TextField
              label={label2 ? label2 : label}
              value={value2}
              onChange={handleChange}
              fullWidth
              variant="outlined"
              margin="normal"
              type="number"
              name={name2}
              error={Boolean(error)}
              helperText={error && helperText}
              required={required}
            />
          </Grid>
        </Grid>
      </>
    );
  } else if (type === "tel") {
    return (
      <Grid>
        {title && <CustomLabel>{title}</CustomLabel>}
        <TextField
          label={label}
          value={value}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          type={type}
          name={name}
          margin="normal"
          error={Boolean(error)}
          helperText={error && helperText}
          placeholder={placeholder}
          inputProps={{
            maxLength: 10,
            inputMode: "numeric",
          }}
          onKeyDown={handleMobileKeyDown}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">+91</InputAdornment>
            ),
          }}
          disabled={disabled}
          required={required}
        />
      </Grid>
    );
  } else if (type === "date") {
    return (
      <Grid sx={{ marginTop: "20px" }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label={
              <>
                {label}
                {required ? " *" : ""}
              </>
            }
            value={value ? dayjs(value) : null}
            onChange={(newValue) =>
              onChange(
                name,
                newValue ? dayjs(newValue).format("YYYY-MM-DD") : null
              )
            }
            slotProps={{
              textField: {
                fullWidth: true,
                error: Boolean(error),
                helperText: error && helperText,
              },
            }}
          />
        </LocalizationProvider>
      </Grid>
    );
  } else if (type === "checkbox") {
    return (
      <FormControl key={name} error={Boolean(error)} sx={{ marginTop: "20px" }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={Boolean(value)}
              onChange={handleChange}
              name={name}
              value={value}
            />
          }
          label={label}
        />
        {error && (
          <FormHelperText style={{ color: "red" }}>{helperText}</FormHelperText>
        )}
      </FormControl>
    );
  }

  // Render regular text field if type is not select or checkboxes
  return (
    <>
      <div style={{ padding: "0px 0" }}>
        {title && <CustomLabel>{title}</CustomLabel>}
        <TextField
          label={label}
          value={value}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          margin="normal"
          type={type}
          name={name}
          error={Boolean(error)}
          helperText={error && helperText}
          placeholder={placeholder}
          required={required}
        />
      </div>
    </>
  );
};

export default CustomTextField;
